import { Navigate, Outlet } from "react-router-dom";

const isAuthenticated = () => {
  var token = localStorage.getItem("token");
  if (token == null) {
    return false;
  } else {
    return true;
  }
};

export const PublicRoute = () => {

  if (isAuthenticated()) {
    return <Navigate to={"/dashboard/quiz"} />;
  }

  return (
      <Outlet className="example" />
  )
};